// @flow
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNotify } from 'react-admin';
import newsfeed from 'helpers/apis/newsfeed';
import { updateNotifications, updateFeed, deleteComment } from 'helpers/action';
import { DeleteConfirmationModal } from 'components';

const DeleteCommentModal = ({ open, close, postId, commentId, onDeleteComment, commentsCount }) => {
  const dispatch = useDispatch();
  const notify = useNotify();

  const handleDeleteComment = () => {
    dispatch(updateFeed(postId, { comments_count: commentsCount - 1 }));
    dispatch(deleteComment(postId, commentId));

    newsfeed
      .deleteComment(commentId, postId)
      .then(res => {
        if (res?.status && res.status === 200) dispatch(updateNotifications(true));
        onDeleteComment(commentId);
        notify(res?.data?.message);
      })
      .catch(err => {
        notify(err?.response?.data?.message || 'Something went wrong', 'error');
      });
    close();
  };

  return (
    <DeleteConfirmationModal
      open={open}
      close={close}
      onDelete={handleDeleteComment}
      title="Delete Comment?"
      description="This comment will be deleted and cannot be recovered."
    />
  );
};

export default DeleteCommentModal;
